import styled from "styled-components";
import PropTypes from "prop-types";
import ConfirmationButton from "./ConfirmationButton";

const Card = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  padding-top: 10px;
  padding-bottom: 14px;
  padding-left: 16px;
  padding-right: 16px;

  max-width: 480px;
  margin-top: 12px;
`;

const VoterName = styled.div`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
`;

const VoterDetails = styled.div`
  margin-top: 2px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 12px;
`;

const voterDisplayName = (snapshot) =>
  [snapshot.first, snapshot.last, snapshot.suffix].filter(Boolean).join(" ");

const voterDetailLine = (snapshot) => {
  const parts = [];
  if (snapshot.city && snapshot.state)
    parts.push(`${snapshot.city}, ${snapshot.state.toUpperCase()}`);
  else if (snapshot.city) parts.push(snapshot.city);
  return parts.join(" · ");
};

const VoterCard = ({ voterId, snapshot, onConfirm }) => (
  <Card>
    <VoterName>{voterDisplayName(snapshot)}</VoterName>
    <VoterDetails>{voterDetailLine(snapshot)}</VoterDetails>
    <ConfirmationButton onClick={() => onConfirm(voterId)} />
  </Card>
);

VoterCard.propTypes = {
  voterId: PropTypes.string,
  snapshot: PropTypes.object,
  onConfirm: PropTypes.func,
};

export default VoterCard;
